import { type ReactNode, use } from 'react';

import i18n, { initI18n } from './i18n/i18n';

export function I18nReady({ children }: { children: ReactNode }) {
	if (!i18n.isInitialized) {
		use(initI18n());
	}
	return <>{children}</>;
}
